import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueScreen from 'vue-screen';
import createRouter from './router';
import VueHead from 'vue-head'

import App from './App.vue';

import store from './store';

// Vue.config.productionTip = false;

const VueScrollTo = require('vue-scrollto');

Vue.use(VueHead)
Vue.use(BootstrapVue);
Vue.use(VueScreen);
Vue.use(VueAxios, axios);
Vue.use(VueScrollTo);

Vue.component('app', App);

// async function updateMetaTags(){
//   if (process.env.VUE_APP_SIDEKICK_SEARCH == 1) {
//     document.querySelector('meta[property="og:description"]').setAttribute("content",
//       'Flow NFT Score sorts and ranks the best NFT projects on Flow by rarity. Check out SNKRHUD Side Kicks and many more soon to come!'
//       );
//     document.querySelector('meta[property="og:title"]').setAttribute("content", 'FLOWNFTSCORE');

//     var og1 = document.createElement("meta");
//     document.head.appendChild(og1)
//     .setAttribute('property', "og:description")
//     .setAttribute('content', "Flow NFT Score sorts and ranks the best NFT projects on Flow by rarity. Check out SNKRHUD Side Kicks and many more soon to come!");
//   } else {
//     document.querySelector('meta[property="og:description"]').setAttribute("content",
//       'Welcome to the SNKRHUD. We are building the only full service sneaker ecosystem that empowers its residents to build their own community by inviting friends, peers, teammates, and classmates while setting the formats, group sizes and topics around the styles that matter most.'
//       );
//     document.querySelector('meta[property="og:title"]').setAttribute("content", 'SNKRHUD');
//   }
// }

// updateMetaTags();
// axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

(async () => {
  const router = typeof createRouter === 'function' ? await createRouter({ Vue }) : createRouter;

  router.afterEach((to, from) => {
    document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  return new Vue({
    el: '#app',
    store,
    router,
    App,
    render: (h) => h(App),
  });
})();
